import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries';

  class AddProcEjec2 extends React.Component{
    state={argsAdd: {}}

  handleChange = async (ev) => {
    const argsAdd = this.state.argsAdd
    let file = "", nombreArchivo = ""
    if(ev.target.files[0]){
      file = ev.target.files[0]
      nombreArchivo = ev.target.files[0].name
    }
    argsAdd['nombreArchivo'] = nombreArchivo
    argsAdd['file'] = file
    this.setState({argsAdd})
  }

  render(){
    const {argsAdd} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let args = Object.assign({}, this.props.args, argsAdd)

  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Código de procedimiento nuevo
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={this.props.styles.label}>Código procedimiento</label>
                  <Form.Input autoComplete="off" name="codProcedimiento" id="codProcedimiento" onChange={this.props.handleChange} placeholder='Código de procedimiento' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codProcedimiento'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Titulo del procedimiento</label>
                  <Form.Input autoComplete="off" name="descrProcedimiento" id="descrProcedimiento" onChange={this.props.handleChange} placeholder='Titulo del procedimiento' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrProcedimiento'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>
                    Seleccionar archivo de procedimiento...&nbsp;&nbsp;
                  </label>
                  <input id="file" name="file" type="file" required style={estilos} onChange={this.handleChange}></input>
                </Form.Field>

                <Button style={this.props.styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
  }
}

export default compose(
  graphql(queries.mutation.singleUpload, {name:'singleUpload'}),

  )(AddProcEjec2)